
const digest = '89166374fb8af9253380758b833420e94e5200e5cf49ad7144a5eab7d058136b';
const classes = {"wrapper":"_wrapper_mdanw_1"};
const css = `._wrapper_mdanw_1 {
  background-color: #ffe1e1;
  padding: 10px 24px;
  border-radius: 9px;
  font-weight: 600;
  color: #8b2e2e;
  border: 1px solid #8b2e2e;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  